import { QueryClient } from '@tanstack/react-query';
import { ApiRequestError } from './api';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Référentiels et listes : 5 min de fraîcheur (UX_ARCHITECTURE §11).
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (error instanceof ApiRequestError) {
            // Inutile de réessayer une erreur métier ou d'autorisation.
            if (error.status >= 400 && error.status < 500) return false;
          }
          return failureCount < 2;
        },
      },
      mutations: { retry: false },
    },
  });
}
